export default "__VITE_ASSET__3etY9UDQ__"